// Report catalog API (Supabase-backed via the FastAPI backend).
const API = process.env.REACT_APP_API_URL || "http://localhost:8002";

export async function listReports(folder) {
  const q = folder ? `?folder=${folder}` : "";
  const r = await fetch(`${API}/api/reports${q}`);
  const d = await r.json();
  if (!r.ok) throw new Error(d.detail || "Failed to load reports");
  return d.reports || [];
}

export async function getReport(id) {
  const r = await fetch(`${API}/api/reports/${id}`);
  const d = await r.json();
  if (!r.ok) throw new Error(d.detail || "Failed to load report");
  return d.report;
}

export async function saveReport({ id, name, folder = "custom", owner, definition }) {
  const r = await fetch(`${API}/api/reports`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, name, folder, owner, definition }),
  });
  const d = await r.json();
  if (!r.ok) throw new Error(d.detail || "Failed to save report");
  return d.report;
}

export async function deleteReport(id) {
  const r = await fetch(`${API}/api/reports/${id}`, { method: "DELETE" });
  const d = await r.json();
  if (!r.ok) throw new Error(d.detail || "Failed to delete report");
  return d;
}
